import { render, staticRenderFns } from "./RegionalAdjustEdit.vue?vue&type=template&id=e9e85d9c&scoped=true"
import script from "./RegionalAdjustEdit.vue?vue&type=script&lang=js"
export * from "./RegionalAdjustEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e85d9c",
  null
  
)

export default component.exports